import React from "react";
import {createRoot} from "react-dom/client";
import "./index.scss";
import App from "./App";
import {DevSupport} from "@react-buddy/ide-toolbox";
import {ComponentPreviews, useInitial} from "./dev";

const container = document.getElementById("root");

if (container) {
  createRoot(container).render(<DevSupport ComponentPreviews={ComponentPreviews}
                                           useInitialHook={useInitial}
  >
    <App/>
  </DevSupport>);
}
